<template>
    <div class="list-programs">
        <div class="program-type" v-if="program.active" v-for="program in product.items" v-bind:class="{ 'module' : program.module }">
            <div
                class="row program-item"
                :class="'group-' + product.name.replace(/\s+/g, '').toLowerCase()"
            >
                <div class="col-md product-name"  >
                    <div class="program-icon">
                        <img v-bind:src="'images/program-icons/' + program.predator + '.svg'" alt="icon">
                    </div>
                    <div class="program-description">
                        <span class="program-description__main">{{ program.name }}</span>
                        <span class="program-description__small">{{ program.description }}</span>
                    </div>
                </div>
                <!-- Starting mobile -->
                <div class="mobile-row d-lg-none">
                    <div class="row no-gutters flex-nowrap">
                        <div class="col col-title">
                            {{ program.program_type=='bundle' ?
                                (getTranslation('product-list-vue', 'package') + ':' ) :
                                (program.program_type=='module' ?
                                    (getTranslation('product-list-vue', 'module') + ':') :
                                    (getTranslation('product-list-vue', 'program') + ':'))
                            }}
                        </div>
                        <div class="col col-info">
                            <div class="program-icon">
                                <img v-bind:src="'images/program-icons/' + program.predator + '.svg'" alt="icon">
                            </div>
                            <div class="program-description">
                                <span class="program-description__main">{{ program.name }}</span>
                                <span class="program-description__small">{{ program.description }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- END  mobile -->

                <div class="col-md-1 col-price" v-if="prefix == 'lease'">
                    {{ priceFormat(getProgramPrice(program.id, '', getQtyName('lease', 'cloud'), program.product, 1, false) || 0) }}
                </div>

                <!-- Starting mobile second col -->
                <div class="mobile-row d-lg-none">
                    <div class="row no-gutters flex-nowrap">
                        <div class="col col-title">
                            <div v-if="prefix == 'lease'" v-html="getTranslation('product-list-vue', 'price_for_lease') + ':'"></div>
                        </div>

                        <div class="col-auto col-info" v-if="prefix == 'lease'">
                            {{ priceFormat(getProgramPrice(program.id, '',  getQtyName('lease', 'cloud'), program.product, 1, true) || 0) }}
                        </div>
                    </div>
                </div>
                <!-- END  mobile second col -->
                <template v-if="product.purchase_options.has_cloud">
                    <div class="col-md-2 program-quantity col-spinner">

                            <button type="button" @click="decreaseQuantity(program, getQtyName(prefix, 'cloud'))">
                                <svg style="width: 9px; height:9px;" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="svg-inline--fa fa-minus fa-w-12 fa-2x"><path fill="currentColor" d="M376 232H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z" ></path></svg>
                            </button>
                            <input class="quantity" @input="addToCart(program, getQtyName(prefix, 'cloud'))"
                                   type="text" pattern="[0-9]+" min="0" step="1" max="99"
                                   v-bind:class="{ 'is-valid': program[ getQtyName(prefix, 'cloud')]  }"
                                   v-model="program[getQtyName(prefix, 'cloud')]"
                                   :name="'programs[' + program.id + '][' + getQtyName(prefix, 'cloud') + ']'"
                            >
                            <button type="button" @click="increaseQuantity(program, getQtyName(prefix, 'cloud'))">
                                <svg style="width: 9px; height:9px;" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="svg-inline--fa fa-plus fa-w-12 fa-2x"><path fill="currentColor" d="M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z" ></path></svg>
                            </button>

                    </div>
                    <div class="col-md-2 program-quantity col-spinner" v-if="isTruss4Product(product.id)">
                    <template v-if="showTrussPeriodSelector(program.product)">

                        <div class="col-auto col-info program-quantity">
                            <select
                                name="period"
                                :id="'period_' + program.id"
                                v-model="trussPeriod"
                                @change="setTrussPeriod($event)"
                            >
                                <option :value="period" v-for="period in trussPeriods" :selected="trussPeriod === period">
                                    {{ translateReplace(period) }}
                                </option>
                            </select>
                        </div>
                    </template>
                    <template v-if="showTrussPeriodText(program.product)">
                        <div class="col col-title">
                            {{ getTranslation('product-list-vue', 'period') }}:
                        </div>
                        <div class="col-auto col-info program-quantity">
                            {{ showTrussPeriodText(program.product) }}
                        </div>
                    </template>
                </div>
                </template>

                <!-- Starting second mobile spinner col -->
                <div class="mobile-row d-lg-none">
                    <div class="row no-gutters flex-nowrap">
                        <template v-if="product.purchase_options.has_cloud">
                            <div class="col col-title">
                                {{ getTranslation('product-list-vue', 'cloud_licences') }}:
                            </div>
                            <div class="col-auto col-info program-quantity">
                                <button type="button" @click="decreaseQuantity(program, getQtyName(prefix, 'cloud'))">
                                    <svg style="width: 9px; height:9px;" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="svg-inline--fa fa-minus fa-w-12 fa-2x"><path fill="currentColor" d="M376 232H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z" ></path></svg>
                                </button>
                                <input class="quantity" @input="addToCart(program, getQtyName(prefix, 'cloud'))"
                                       type="text" pattern="[0-9]+" min="0" step="1" max="999"
                                       v-bind:class="{ 'is-valid': program[ getQtyName(prefix, 'cloud')]  }"
                                       v-model="program[getQtyName(prefix, 'cloud')]"
                                       :name="'programs[' + program.id + '][' + getQtyName(prefix, 'cloud') + ']'"
                                >
                                <button type="button" @click="increaseQuantity(program, getQtyName(prefix, 'cloud'))">
                                    <svg style="width: 9px; height:9px;" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="svg-inline--fa fa-plus fa-w-12 fa-2x"><path fill="currentColor" d="M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z" ></path></svg>
                                </button>
                            </div>
                        </template>



                    </div>
                </div>
                <!-- END  second mobile spinner col -->


                <!-- Starting second mobile spinner col -->
                <div class="mobile-row d-lg-none">
                    <div class="row no-gutters flex-nowrap">


                        <template v-if="showTrussPeriodSelector(program.product)">
                            <div class="col col-title">
                                {{ getTranslation('product-list-vue', 'period') }}:
                            </div>
                            <div class="col-auto col-info program-quantity">
                                <select
                                name="period"
                                :id="'period_' + program.id"
                                v-model="trussPeriod"
                                @change="setTrussPeriod($event)"
                            >
                                <option :value="period" v-for="period in trussPeriods" :selected="trussPeriod === period">
                                    {{ translateReplace(period) }}
                                </option>
                            </select>
                            </div>
                        </template>
                        <template v-if="showTrussPeriodText(program.product)">
                            <div class="col col-title">
                                {{ getTranslation('product-list-vue', 'period') }}:
                            </div>
                            <div class="col-auto col-info program-quantity">
                                {{ showTrussPeriodText(program.product) }}
                            </div>
                        </template>

                    </div>
                </div>
                <!-- END  second mobile spinner col -->

                <div class="col-md-1 col-price col-price--total" v-if="$store.state.cart.loggedInUser">
                    {{ getExistingLicensesCount(program) }}
                </div>
                <div class="col-md-2 col-price col-price--total">
                    {{ rowPrice(program) }}
                </div>

                <!-- start total price mobile -->
                <div class="mobile-row total-price--mobile d-lg-none">
                    <div class="row no-gutters flex-nowrap" v-if="$store.state.cart.loggedInUser && getExistingLicensesCount(program)">
                        <div class="col col-title">
                            <b v-html="getTranslation('product-list-vue', 'existing_licenses')"></b>
                        </div>
                        <div class="col-auto col-info">
                            {{ getExistingLicensesCount(program) }}
                        </div>
                    </div>
                    <div class="row no-gutters flex-nowrap">
                        <div class="col col-title">
                            <b>{{ getTranslation('front', 'total') }}:</b>
                        </div>
                        <div class="col-auto col-info">
                            {{ rowPrice(program) }}
                        </div>
                    </div>
                </div>
                <!-- END total price mobile -->
            </div>
        </div>

        <div id="bundles"></div>
    </div>
</template>


<script>
    export default {
        methods: {
            showTrussPeriodSelector(productId) {
                if (this.product.purchase_options.period_selector == false) {
                    return false;
                }
                if (this.hasTruss4Lease(productId)) {
                    return false;
                }
                if (this.hasTruss4GraceLease(productId)) {
                    return false;
                }
                return true;
            },
            translateReplace(period) {
                return _.replace(this.translateLeaseEnd(period), /["'()]/g, '');
            },
            showTrussPeriodText(productId) {
                if (this.product.purchase_options.has_network) {
                    return false;
                }

                if (this.hasTruss4GraceLease(productId)) {
                    return this.translateLeaseEnd( this.product.grace_lease_agreement.months);
                }
                if (this.hasTruss4Lease(productId) || this.hasTruss4GraceLease(productId)) {
                    return this.translateLeaseEnd( this.product.active_lease_agreement.months );
                }
                return false;
            },
            setTrussPeriod(event) {
                let payload = event.target.value;
                this.$store.commit('setTrussPeriod', payload);
                this.resetCartStep();
            },
            toggle(id, collapseId) {
                if (document.getElementById(id).classList.contains('not-collapsed')) {
                    this.scrollToElement(collapseId);
                }
            },
            getItemQty(type, licenceType, program) {
                let found  =_.findIndex(this.$store.state.cart.programs, function(pr) { return pr.id == program; });
                if (found == -1) {
                    return '';
                }
                return this.$store.state.cart.programs[found][this.getQtyName(type, licenceType)] || '';
            },
            rowPrice(program) {
                let price = 0;
                let qtyType = this.getQtyName(this.prefix, 'cloud');

                if (_.isNil(this.$store.state.cart)) {
                    return this.priceFormat(price)
                }
                let found  =_.findIndex(this.$store.state.cart.programs, function(pr) { return pr.id == program.id; });
                if (found >= 0) {
                    let p = this.$store.state.cart.programs[found];
                    price = this.getProgramPrice(program.id, '', qtyType, program.product, p[qtyType] );
                }

                return this.priceFormat(price)
            },
            scrollToElement(id) {

                if (document.getElementById(id).getBoundingClientRect().top < 0) {
                    document.getElementById(id).scrollIntoView({behavior: "auto", block: "start", inline: "start"});
                }

            },
            addToCart(item, licenceType) {
                let quantity = (parseInt(item[licenceType]) || 0);
                let displayQty = quantity;
                if (quantity < 0) {
                    quantity = 0;
                    displayQty = '';
                }
                let maxLimit = 999;
                if (licenceType == 'local' || licenceType == 'lease_local') {
                    maxLimit = 99
                }
                if (quantity > maxLimit) {
                    quantity = maxLimit;
                    displayQty = maxLimit;
                }

                // item[licenceType] = quantity;
                this.checkParentQty(item, licenceType, quantity);
                this.commitToCart(item, licenceType, quantity);
                this.checkModuleQty(item, licenceType, quantity);
                displayQty = displayQty.toString();
                if (displayQty === '0') {
                    displayQty = '';
                }
                item[licenceType] = displayQty;

            },
            commitToCart(item, licenceType, quantity) {
                let payload = {'item': item, 'licenceType': licenceType, 'quantity': quantity};
                this.$store.commit('addToCart', payload);

                let found  =_.findIndex(this.product.items, function(pr) { return pr.id == item.id; });
                if (found !== 0) {
                    let displayQty = quantity.toString();
                    if (displayQty === '0') {
                        displayQty = '';
                    }
                    this.product.items[found][licenceType] = displayQty;
                }
                this.resetCartStep();
            },
            increaseQuantity(item, licenceType) {
                let quantity = (parseInt(item[licenceType]) || 0) + 1;

                let maxLimit = 999;
                if (licenceType == 'local' || licenceType == 'lease_local') {
                    maxLimit = 99
                }
                if (quantity > maxLimit) {
                    quantity = maxLimit;
                }
                let displayQty = quantity;
                if (quantity <= 0) {
                    quantity = 0;
                    displayQty = "";
                }

                this.checkParentQty(item, licenceType, quantity);

                this.commitToCart(item, licenceType, quantity);
                this.resetCartStep();

                item[licenceType] = displayQty;
            },
            decreaseQuantity(item, licenceType) {
                let quantity = (parseInt(item[licenceType]) || 0) - 1;
                let displayQty = quantity;
                if (quantity <= 0) {
                    quantity = 0;
                    displayQty = "";
                }
                // item[licenceType] = displayQty;

                this.commitToCart(item, licenceType, quantity);
                this.checkModuleQty(item, licenceType, quantity);

                item[licenceType] = displayQty;
            },
            checkExistingLicenceQty(id, licenceType) {
                //check existing licence  quantity
                let totalExistingParent = 0;
                let type = licenceType;
                if (licenceType == 'lease_local') {
                    type = 'local_lease'
                } else if (licenceType == 'lease_network') {
                    type = 'network_lease';
                } else if (licenceType == 'cloud_perpetual_quantity') {
                    type = 'cloud_perpetual';
                } else if (licenceType == 'cloud_time_quantity') {
                    type = 'cloud_time';
                }

                let parentExistingLicence = _.filter(this.existingLicences, function(l) {
                    return (l.program_id == id && l.licence_type == type);
                });

                if (!_.isUndefined(parentExistingLicence)) {
                    totalExistingParent = _.sumBy(parentExistingLicence, 'quantity');
                }
                return _.toNumber(totalExistingParent);
            },
            checkBundleQty(id, parent, licenceType) {
                let self = this;
                let totalExistingBundle = 0;
                let type = licenceType;

                //check in existing bundles
                _.forEach(this.existingLicences, function(l) {
                    if (l.pkg == '1' && l.licence_type == type) {
                        let program = _.find(self.products[l.product].items, { 'id': l.program_id });
                        if (
                            !_.isNil(program) &&
                            program.program_type === 'bundle' &&
                            _.indexOf(program.singleLicences, parent) >=0 &&
                            _.indexOf(program.singleLicences, id) < 0
                        ) {
                            totalExistingBundle = _.toNumber(totalExistingBundle) + _.toNumber(l.quantity);
                        }
                    }
                });

                //check in cart bundles
                let parentCartBundle = _.filter(this.$store.state.cart.programs, function(l) {
                    return (
                        l.program_type === 'bundle' &&
                        _.indexOf(l.singleLicences, parent) >=0 &&
                        _.indexOf(l.singleLicences, id) < 0
                    )
                });

                if (!_.isUndefined(parentCartBundle)) {
                    totalExistingBundle += _.toNumber(_.sumBy(parentCartBundle, licenceType));
                }

                return _.toNumber(totalExistingBundle);
            },
            getExistingLicensesCount(program) {
                //lease_end
                let self = this;
                let items = _.filter(this.existingLicences, function(l) {
                    return (l.program_id === program.id && self.dateIsInFuture(l.lease_end));
                });
                let totalExistingParent = _.sumBy(items, 'quantity');
                return _.toNumber(totalExistingParent) || '';
            },
            dateIsInFuture(date) {
                const now = new Date();
                return new Date(date) > now;
            },
            checkParentQty(item, licenceType, quantity) {
                if (item.product != this.product.id) {
                    return false;
                }
                if (item.module == '1') {
                    let parentItem = _.find(this.product.items, { 'id': item.parent_program });
                    let parentCartItem = _.find(this.$store.state.cart.programs, { 'id': item.parent_program });

                    let parentExistingQty = this.checkExistingLicenceQty(item.parent_program, licenceType);
                    let thisExistingQty = this.checkExistingLicenceQty(item.id, licenceType);
                    let bundleQty = this.checkBundleQty(item.id, item.parent_program, licenceType);
                    let requireExtra = quantity - bundleQty - (parentExistingQty - thisExistingQty);

                    if (_.isUndefined(parentCartItem) && requireExtra > 0) {
                        parentItem[licenceType] = requireExtra;
                        let payload = {'item': parentItem, 'licenceType': licenceType, 'quantity': requireExtra};
                        this.$store.commit('addToCart', payload);
                    } else if (parentItem[licenceType] < quantity && requireExtra > 0 && parentItem[licenceType] < requireExtra) {
                        parentItem[licenceType] = requireExtra;
                        let payload = {'item': parentItem, 'licenceType': licenceType, 'quantity': requireExtra};
                        this.$store.commit('addToCart', payload);
                    }
                }
            },
            checkModuleQty(item, licenceType, quantity) {
                //decrease module items qty if reduce parent qty
                let self = this;

                // let modules = _.filter(this.product.items, { 'parent_program': item.id });
                let modules = _.filter(this.product.items, function(m) { return m.module === 1 });
                //or parent is packages
                if (modules.length > 0) {
                    _.forEach(modules, function(module) {
                        let moduleCartItem = _.find(self.$store.state.cart.programs, { 'id': module.id });
                        if (!_.isUndefined(moduleCartItem)) {
                            let parentQty = 0;
                            let parentCartItem = _.find(self.$store.state.cart.programs, { 'id': module.parent_program });
                            if (!_.isNil(parentCartItem)) {
                                parentQty = parentCartItem[licenceType];
                            }

                            let thisExistingQty = self.checkExistingLicenceQty(module.parent_program, licenceType);
                            let moduleExistingQty = self.checkExistingLicenceQty(module.id, licenceType);
                            let bundleQty = self.checkBundleQty(module.id, module.parent_program, licenceType);

                            let canHaveMax = parentQty + thisExistingQty + bundleQty - moduleExistingQty;

                            if (canHaveMax < moduleCartItem[licenceType]) {
                                module[licenceType] = canHaveMax;

                                let payload = {'item': module, 'licenceType': licenceType, 'quantity': canHaveMax};
                                self.$store.commit('addToCart', payload);
                                if (canHaveMax <= 0) {
                                    module[licenceType] = "";
                                }
                            }
                        }
                    });
                }
            },
            resetCartStep() {
                let payload = {'step': 1};
                this.$store.commit('setCartStep', payload);
                this.$store.commit('emptyHardlocks');
                this.$store.commit('setMustConfirm', 1);
                this.$store.commit('addPromoLease', {});
                this.$store.commit('addPromoLease', {});
                this.deleteLeaseProlongData();
            },
            deleteLeaseProlongData() {
                let self = this;
                //delete the options
                _.forOwn(this.products, function(p) {
                    if (!self.isTruss4Product(p.id)) {
                        let payload = {product: p.id};
                        self.$store.commit('deleteLeaseProlongConfig', payload);
                        self.$store.commit('updateLeaseOptions', {
                            id: p.id,
                            data: {},
                        });
                    }
                });

                //delete the days
                _.forOwn(this.$store.state.cart.programs, function(p) {
                    //clear the custom days
                    let payload = {
                        id: p.id,
                        upgrade: false,
                        column: 'days'
                    }
                    self.$store.commit('upgradeCartProgram', payload);

                    //clear the perpetual upgrade
                    payload = {
                        id: p.id,
                        upgrade: false,
                        column: 'perpetual_upgrade'
                    }
                    self.$store.commit('upgradeCartProgram', payload);
                });
            }
        },
        data() {
            return {
                products: window.jsonProducts,
                existingLicences: window.licences,
                justLoggedIn: window.justLoggedIn,
                justLoggedOut: window.justLoggedOut,
            };
        },
        beforeMount() {
            let self = this;
            this.existingLicences = JSON.parse(this.existingLicences);
            if (!_.isEmpty(this.$store.state.cart.programs)) {
                _.forEach(this.$store.state.cart.programs, function(p) {
                    if (p.module  == 1) {

                        if (p['local_quantity']) {
                            self.checkParentQty(p, 'local_quantity', p['local_quantity']);
                        }
                        if (p['network_quantity']) {
                            self.checkParentQty(p, 'network_quantity', p['network_quantity']);
                        }
                        if (p['lease_local_quantity']) {
                            self.checkParentQty(p, 'lease_local_quantity', p['lease_local_quantity']);
                        }
                        if (p['lease_network_quantity']) {
                            self.checkParentQty(p, 'lease_network_quantity', p['lease_network_quantity']);
                        }
                        if (p['cloud_perpetual_quantity']) {
                            self.checkParentQty(p, 'cloud_perpetual_quantity', p['cloud_perpetual_quantity']);
                        }
                        if (p['cloud_time_quantity']) {
                            self.checkParentQty(p, 'cloud_time_quantity', p['cloud_time_quantity']);
                        }

                    }

                    let found  =_.findIndex(self.product.items, function(pr) { return pr.id == p.id; });
                    if (found !== -1) {
                        let qtyName = self.getQtyName('perpetual', 'cloud');
                        self.product.items[found][qtyName] = p[qtyName] || "";
                        qtyName = self.getQtyName('lease', 'cloud');
                        self.product.items[found][qtyName] = p[qtyName] || "";
                    }
                });

            }

            this.trussPeriod = Number(this.$store.state.cart.trussPeriod);
            this.trussPeriods = [12,6,3];
        },
        props: {
            product: Object,
            prefix: String,
        }
    }
</script>

<style>
    .col-price--total {white-space: nowrap}
    .col-price {white-space: nowrap}
</style>
